// client/extensions/ExtensionBase.ts
import { Transformer } from "./transformers/Transformer.js";
var isTiptapExtension = (extension) => !(extension instanceof Transformer);
var isTransformer = (extension) => extension instanceof Transformer;
export {
  isTiptapExtension,
  isTransformer
};
